<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-1"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <div v-show="isLoadingData" class="flex layout-row">
        <tiny-progress-view :visible="true" text="laden"></tiny-progress-view>
      </div>

      <div v-if="showContent==='upload'" class="flex layout-row">
        <import-upload @check-pending-import="checkPendingImport"></import-upload>
      </div>

      <div v-if="showContent==='overview'" class="flex layout-row">
        <import-overview @check-pending-import="checkPendingImport" :reloadTable="reloadTable"></import-overview>
      </div>

    </div>
  </div>
</template>

<script>
import ImportUpload from './ImportUpload'
import ImportOverview from './ImportOverview'

export default {
  name: 'Import',
  components: {
    ImportUpload,
    ImportOverview
  },
  data () {
    return {
      reloadTable: false,
      isLoadingData: true,
      showContent: null
    }
  },
  created () {
    this.checkPendingImport()
  },
  methods: {
    /**
     * Get import data to check whether an import is possible
     */
    checkPendingImport () {
      this.$http.get('/import/data?config={"opts":{"limit":1}}')
        .then(response => {
          this.isLoadingData = false

          if (response.data && Array.isArray(response.data.items) && response.data.items.length > 0) {
            // Import exists
            this.showContent = 'overview'
            this.reloadTable = !this.reloadTable
          } else {
            // Import not exists
            this.showContent = 'upload'
          }
        })
        .catch(this.NotifyError)
    }
  },
  watch: {
    '$route' (to) {
      if (to.name === 'Import') {
        // Trigger 'checkPendingImport()' on parent
        this.$emit('check-pending-import')
      }
    }
  }
}
</script>

